import React from "react";
import "./Orders.css";

function Orders() {
    return (
        <div className={"orders"}>
            <h1>Order Successful</h1>

        </div>
    )

}

export default Orders;
